import axios from "axios";
axios.defaults.withCredentials = true;
const url = process.env.API_URL;

axios.interceptors.request.use((req) => {
  if (localStorage.getItem("SessionID")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("SessionID")).session.accessToken
    }`;
  }

  return req;
});

export const fetchArticles = () => axios.get(`${url}/articles`);

export const addComment = (comment) =>
  axios.post(`${url}/article/:name/add-comment`, comment);
export const createArticle = (formData) =>
  axios.post(`${url}/article`, formData);

export const searchArticle = (articleTitle) =>
  axios.post(`${url}/article/data/search`, articleTitle);
export const findArticleName = (name) => axios.get(`${url}/article/${name}`);

export const fetchPopularPosts = () =>
  axios.get(`${url}/article/top/most-commented`);
export const addRating = (data, name) =>
  axios.post(`${url}/article/rating/${name}`, data);
export const fetchArticlesAuthoredBy = (id) =>
  axios.get(`${url}/account/articles/${id}`);
export const deleteArticle = (id) =>
  axios.delete(`${url}/article/delete/${id}`);
// export const calculateRating = (articleId) =>
//   axios.get(`${url}/article/calculate/avgRating`, articleId);
// export const checkUserRating = (name) =>
//   axios.get(`${url}/article/checkRating/${name}`);

export const signup = (formData) => axios.post(`${url}/signup`, formData);
export const signin = (formData) => axios.post(`${url}/signin`, formData);
export const getUser = (id) => axios.get(`${url}/account/user/${id}`);
